// src/components/CaptchaGate.jsx
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Turnstile } from "@marsidev/react-turnstile";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY; // or process.env for CRA

export default function CaptchaGate({ children, redirectTo }) {
	const history = useHistory();
	const [verified, setVerified] = useState(false);
	const [error, setError] = useState(false);

	const handleSuccess = async (token) => {
		try {
			const res = await fetch(
				`${process.env.REACT_APP_PUBLIC_URL}/verify-captcha`,
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ token }),
				}
			);
			const data = await res.json();

			if (data.success) {
				setVerified(true);
				if (redirectTo) {
					history.push(redirectTo); // <-- actually navigates
				}
			} else {
				setError(true);
			}
		} catch {
			setError(true);
		}
	};

	if (verified && !redirectTo) return children;
	if (verified && redirectTo) return null; // navigating away, nothing to render here

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				marginTop: 80,
			}}
		>
			<p>Please verify you're human to continue.</p>
			<Turnstile
				siteKey={SITE_KEY}
				onSuccess={handleSuccess}
				onError={() => setError(true)}
			/>
			{error && (
				<p style={{ color: "red" }}>
					Verification failed. Please try again.
				</p>
			)}
		</div>
	);
}

/* export default function CaptchaGate({ children }) {
	const [verified, setVerified] = useState(false);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleSuccess = async (token) => {
		setLoading(true);
		setError(false);
		try {
			const res = await fetch("/verify-captcha", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ token }),
			});
			const data = await res.json();
			if (data.success) setVerified(true);
			else setError(true);
		} catch {
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	if (verified) return children;

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				marginTop: 80,
				gap: 12,
			}}
		>
			<p>Please verify you're human to continue.</p>

			<Turnstile
				siteKey={SITE_KEY}
				options={{ appearance: "always" }}
				onSuccess={handleSuccess}
				onError={() => setError(true)}
				onExpire={() => setError(true)}
			/>

			{loading && <p>Verifying...</p>}
			{error && (
				<p style={{ color: "red" }}>
					Verification failed. Please try again.
				</p>
			)}
		</div>
	);
}
 */
